<template>
  <div>
    <el-row style="margin-bottom: 20px">
      <el-col :span="4">
        <el-upload
          class="upload-demo"
          :action="`${this.getaway.user}/bt/file/upload/mp4`"
          :on-remove="handleRemove"
          :on-success="successRemove"
          :before-upload="beforeAvatarUpload"
          :limit="1"
          :on-exceed="handleExceed">
          <el-button size="small" v-if="uploadStatus">点击上传</el-button>
        </el-upload>
      </el-col>
      <el-col :span="10" v-if="uploadStatus && fileInfo">
        <el-button @click="handleRemove">删除</el-button>
      </el-col>
    </el-row>

    <div class="video_box" v-if="fileInfo">
      <video :src="fileInfo" autoplay=autoplay controls=controls
             muted=muted loop=loop poster="video/mp4"></video>
    </div>
  </div>
</template>

<script>
export default {
  name: "qqVideoNew",
  props: {
    videoMd5: {
      type: String,
      default: ''
    },
    uploadStatus: {
      type: Boolean,
      default: true
    }
  },
  //定义v-model属性
  model: {
    prop: 'videoMd5',
    event: 'change'
  },
  data() {
    return {
      fileList: [],
      fileInfo: '',
    }
  },
  watch: {
    //监听视频的修改
    videoMd5(val) {
      this.fileInfo = val
    }
  },
  created() {
    this.initialize()
  },
  methods: {
    initialize() {
      if (this.videoMd5) {
        this.fileInfo = this.videoMd5
      }
    },

    beforeAvatarUpload(file) {
      const isJPG = file.type === 'video/mp4';
      if (!isJPG) {
        this.$message.error('只能上传mp4格式');
        return false
      }
      // return file.type === 'video/mp4'

    },

    // 上传文件后
    successRemove(response) {
      if (response.code === '0') {
        // this.fileInfo = response.data.md5.split(".")[0]
        this.fileInfo = response.data.realPath
        this.$emit('change', this.fileInfo)
      }
    },

    //删除文件
    handleRemove() {
      this.fileInfo = ''
      this.$emit('change', this.fileInfo)
    },

    //限制文件数量
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },

    //删除之前
    /*beforeRemove(file) {
      return this.$confirm(`确定移除 ${ file.name }？`);
    }*/
  }
}
</script>

<style lang="less" scoped>
/deep/.el-upload-list {
  display: none;
}
</style>
